import { useState } from 'react'

import { Button, Input, Select } from '@ui/components/core'
import { CreateMemberInput } from '@ui/services'

interface InviteUserFormProps {
  onSubmit: (data: CreateMemberInput) => void
  isLoading: boolean
  onClose: () => void
}

export const InviteUserForm = ({ isLoading, onSubmit, onClose }: InviteUserFormProps) => {
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [role, setRole] = useState<string>('standard') // TODO: Standardized the roles in an enum

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit({
      email,
      first_name: firstName,
      last_name: lastName,
      role,
    })
  }

  return (
    <form className="space-y-4 p-6" onSubmit={handleSubmit}>
      <div className="w-full">
        <Input
          label="First Name"
          placeholder="Enter member's first name"
          onChange={(e) => setFirstName(e.target.value)}
          value={firstName}
        />
      </div>

      <div className="w-full">
        <Input
          label="Last Name"
          placeholder="Enter member's last name"
          onChange={(e) => setLastName(e.target.value)}
          value={lastName}
        />
      </div>

      <div className="w-full">
        <Input
          label="Email"
          placeholder="Enter member's email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
      </div>

      <div className="w-full">
        <label htmlFor="role" className="block text-sm font-medium leading-6 text-gray-900">
          Role
        </label>
        <div className="mt-2">
          <Select
            name="role"
            id="role"
            onChange={(role) => setRole(role as string)}
            value={role}
            defaultValue="standard"
            options={[
              { value: 'admin', label: 'Admin' },
              { value: 'standard', label: 'Standard' },
            ]}
          />
        </div>
      </div>

      <div className="w-full">
        {/* <Notification
            show={notification !== null}
            type={NotificationTypeEnum.ERROR}
            title={notification?.title || ''}
            message={notification?.message}
            richMessage={notification?.richMessage}
            messageList={notification?.messageList}
          /> */}
      </div>

      <div className="mt-8 flex justify-end space-x-2">
        <Button type="submit" disabled={isLoading} variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" disabled={isLoading}>
          Invite
        </Button>
      </div>
    </form>
  )
}
